/**
 * SearchInput - Mobile
 * 
 * Search field with icon.
 * Clean, functional, no decoration.
 */

import React from 'react';
import { View, TextInput, StyleSheet, Pressable } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { color, text, space, radius, border, touch } from '../../../shared/tokens/mobile';

interface SearchInputProps {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
}

export function SearchInput({ 
  value, 
  onChangeText, 
  placeholder = 'Search...' 
}: SearchInputProps) {
  const showClear = value.length > 0;

  return (
    <View style={styles.container}>
      <Ionicons name="search-outline" size={18} color={color.textMuted} />
      <TextInput
        style={styles.input}
        value={value}
        onChangeText={onChangeText}
        placeholder={placeholder}
        placeholderTextColor={color.textMuted}
        autoCapitalize="none"
        autoCorrect={false}
        returnKeyType="search"
      />
      {showClear && (
        <Pressable onPress={() => onChangeText('')} hitSlop={space.sm}>
          <Ionicons name="close-circle" size={18} color={color.textMuted} />
        </Pressable>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: color.surface,
    borderRadius: radius.md,
    borderWidth: border.width.thin,
    borderColor: color.border,
    paddingHorizontal: space.sm + space.xs,
    minHeight: touch.minimum,
    gap: space.sm,
  },
  input: {
    flex: 1,
    fontSize: text.body.fontSize,
    fontWeight: text.body.fontWeight,
    color: color.textPrimary,
    paddingVertical: space.sm,
  },
});

